import {Injectable} from '@angular/core';
import {RoleTypeEnum} from '../../enums/role-type.enum';
import {UserDataService} from '../user-data/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class UserPrivilegeService {

  constructor(private userDataService: UserDataService) {
  }

  isAuthorized(role: RoleTypeEnum = null): boolean {
    const roles = this.userDataService?.getData()?.roles;

    if (roles === undefined || roles === null) {
      return false;
    }

    if (role === RoleTypeEnum.SECURITY_ADMIN &&
      !roles.includes(RoleTypeEnum.SECURITY_ADMIN)) {
      return false;
    }

    if (roles.includes(RoleTypeEnum.ADMIN) ||
      roles.includes(RoleTypeEnum.SECURITY_ADMIN) ||
      roles.includes(role)) {
      return true;
    }

    return false;
  }
}
